<template>
   <div class="card mt-4 text-left p-3 bg-white border border-white" :class="classCustom">
    <p class="mb-3">
      <span class="ml-3">
        <img
          width="35px"
          class="rounded-circle d-inline mt-4"
          src="@/assets/images/arrow-down.png"
          alt=""
        />
      </span>
      <strong class="ml-2">
        <span class="h6">
          {{ $t(
            'lang.onBoarding.example',
            this.$store.state.onboarding.lang
          )}}
        </span>
      </strong>
    </p>
    <p v-if="message" class="text-size-20 mb-4">
      <strong>
        <span class="text-primary">{{ message.substr(0, message.indexOf(',') + 1) }}</span>
      </strong>
      {{ message.substr( message.indexOf(',') + 1) }}
    </p>
    <div v-if="textHtml != null" v-html="textHtml" class="text-size-20 mb-4">
    </div>
    <template v-if="items.length > 0">
      <p v-for="(item, i) of items" :key="i" class="text-size-20">
        {{ i + 1}}. {{item}}
      </p>
    </template>
    <p class="mt-4 text-muted" v-if="question" v-html="question">
    </p>
  </div>
</template>

<script>
export default {
  name: 'Example',
  props: {
    message: {
      type: String,
      default: ''
    },
    question: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      required: false,
	    default: () => [],
    },
     textHtml: {
      type: String,
      default: null
    },
    classCustom: {
      type: String,
      default: ''
    }
  },

  data() {
    return {};
  },
  methods: {},
};
</script>
<style scoped>
.text-size-20 {
  font-size: 20px;
}
</style>
